import { render, staticRenderFns } from "./AlternateHSQualifierUnder4.vue?vue&type=template&id=a35a4cac&scoped=true&"
import script from "./AlternateHSQualifierUnder4.vue?vue&type=script&lang=ts&"
export * from "./AlternateHSQualifierUnder4.vue?vue&type=script&lang=ts&"
import style0 from "./AlternateHSQualifierUnder4.vue?vue&type=style&index=0&id=a35a4cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35a4cac",
  null
  
)

export default component.exports